import { Box, HStack } from "@chakra-ui/react";
import { Icon } from "../../../components/Icon";

/**
 * @typedef {Object} Props
 * @property {string} icon
 * @property {React.ReactNode} children
 */

/**
 * @param {Props} props
 */
export function LayoutByInformation({ icon, children }) {
  return (
    <HStack alignItems="flex-start">
      <Box>
        <Icon icon={icon} size="1.75rem" color="white" />
      </Box>

      {children}
    </HStack>
  );
}
